<!--
 * @Author: your name
 * @Date: 2020-08-12 17:18:12
 * @LastEditTime: 2022-11-14 10:48:03
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/Order/Items.vue
-->
<style scoped lang="sass">
::v-deep
  .material-icons
    text-align: center
    font-size: 15px
    font-weight: 700
    line-height: 20px

.order_items
  padding: 16px
  display: flex
  justify-content: space-between

  .left_combo,
  .left
    flex: 1
    display: flex
    flex-direction: column
    margin-right: 20px

    .title
      font-size: 14px
      color: var(--menu-primary-text-colour)

  .right_part
    display: flex

    .right
      display: flex
      flex-direction: column
      align-items: flex-end
      justify-content: space-between
      max-width: 50px
      margin-left: 25px
      min-height: 60px

      .price
        line-height: 18px
        font-size: 12px
        color: var(--menu-primary-text-colour)

      .opertion
        display: flex

        .edit
          width: 20px
          height: 20px
          margin-right: 20px
          border-radius: 50%
          color: var(--menu-primary-background-colour) !important

        .del
          width: 20px
          height: 20px
          border-radius: 20px
          background: rgba(176, 6, 32, 1)

::v-deep
  .van-stepper__input
    color: var(--menu-primary-text-colour) !important
</style>
<style lang="sass" scoped>
.expire
  .left .title,
  .left .detail,
  .right_part .price
    text-decoration: line-through

  .error_text
    margin-top: 2px
    color: #B00620
    font-size: 12px

::v-deep

  .van-stepper__minus::before,
  .van-stepper__plus::before
    height: 2px
    border-radius: 2px

  .van-stepper__minus::after,
  .van-stepper__plus::after
    width: 2px
    border-radius: 2px

.first
  margin-right: 10px

  .num
    font-size: 14px
    color: var(--menu-primary-text-colour)

.combo_title
  margin-top: 2px
  font-size: 14px
  font-weight: 500
  color: var(--menu-primary-text-colour)

  .side_dish
    display: flex
    flex-wrap: wrap

    .side_dish_title
      margin-right: 2px

    .side_dish_box
      flex: 1
      display: flex
      flex-wrap: wrap

    .side_dish_item
      display: flex
      flex-wrap: wrap
      margin-right: 2px
      font-weight: 400
</style>
<template lang="pug">
.order_items(:class="{ 'expire': isExpire }")
  .first
    .num.b {{ data.num }}
  .left(v-if="data.type !== 'combo'")
    OrderItemsContent(:data="data" :isExpire="isExpire")
  .left_combo(v-else)
    .title.b {{ localizedComboName }}
    div(v-for="(combo, index) in data.comboProducts" :key="index")
      div(v-if="item.isPlus === 'noSideDish'" v-for="(item, itemIndex) in combo.itemList" :key="itemIndex")
        OrderItemsContent(:data="item" :isExpire="isExpire" isCombo)
    .combo_title(v-if="sideDish.optionalList.length > 0 || sideDish.remove.length > 0 || sideDish.requiredList.length > 0")
      .b {{ t('combo_modifications', 'Combo Modifications:') }}
      .side_dish.o5(v-if="sideDish.requiredList.length")
        .side_dish_box
          .side_dish_item(v-for="(item, index) in sideDish.requiredList") {{ index === 0 ? '' : ',' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}

      .side_dish.o5(v-if="sideDish.optionalList.length")
        .side_dish_title {{ t('add_label', 'Add:') }}
        .side_dish_box
          .side_dish_item(v-for="(item, index) in sideDish.optionalList") {{ index === 0 ? '' : ',' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}

      .side_dish.o5(v-if="sideDish.remove.length")
        .side_dish_title {{ t('remove_label', 'Remove:') }}
        .side_dish_box
          .side_dish_item(v-for="(item, index) in sideDish.remove") {{ index === 0 ? '' : ',' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}

  .right_part
    .right
      .price.o {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ productPrice }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .opertion(v-if="!data.disableOperation")
        icon.p(v-if="!isExpire" size="25" @click="editProduct").edit create
        icon.p(color="#fff" @click="delProduct").del clear
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import OrderItemsContent from '../ItemsContent'
import mixin from '@/utils/mixin'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { getLocalizedField, t } from '@/utils/language'
import { markOfLine, subGroupMarkOfLine } from '@/utils/menu/cartMarks'

@Component({
  props: {
    data: {
      type: Object
    },

    index: {
      type: Number
    },
    isSubGroupMode: {
      type: Boolean,
      default: false
    },
    selectVID: {
      type: [String],
      default: ''
    },
  },

  components: {
    OrderItemsContent
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language?.currentLanguage
    },

    productPrice() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      if (this.data.realProductPrice) return formatDecimalNumber(convertPrice(parseFloat(this.data.realProductPrice) * this.data.num))
      return formatDecimalNumber(convertPrice(parseFloat(this.data.price) * this.data.num))
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    number() {
      return this.$store.state.venueHome.routerInfo.number
    },

    venueId() {
      return this.$store.state.venueId
    },

    productGroupId() {
      return this.data.productGroupId
    },

    // Expired Product List
    // 过期商品的列表
    expireProductList () {
      return this.$store.state.expireProductList
    },

    // Expired or not
    // 是否过期（多版本菜单 B6 U-B6-2 review 第 2 轮 G3：本功能写的标记不算在店家强塞的行上，那一行删不掉；老标记照今天按 id）。
    // review 第 3 轮 H3：合单购物车的行（isSubGroupMode）不看「不在当前菜单上」的标记（合单一律主菜单）；单店的行照旧
    isExpire() {
      if (this.isSubGroupMode) return subGroupMarkOfLine(this.expireProductList, this.data)
      return markOfLine(this.expireProductList, this.data)
    },

    // Data modifications list
    // data 配菜列表
    sideDish() {
      const sideDishList = {
        optionalList: [],
        requiredList: [],
        remove: []
      }
      // IsPlus > 0 to add, isPlus < 0 to remove
      // isPlus > 0 时，添加到 add。isPlus < 0 时，添加到 remove。
      this.data.comboProducts.forEach(item => {
        item.itemList.forEach(ls => {
          if (ls.isPlus !== 'noSideDish') {
            if (ls.isPlus >= 0) {
              if (item.type === 'optional') {
                sideDishList.optionalList.push(ls)
              } else {
                sideDishList.requiredList.push(ls)
              }
            } else {
              sideDishList.remove.push(ls)
            }
          }
        })
      })
      return sideDishList
    },
  },
})

class OrderItems extends mixins(mixin) {
  // Get localized combo name / 获取本地化的套餐名称
  get localizedComboName() {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return this.data.upgradeProductName || getLocalizedField(this.data, 'name') || this.data.name
  }

  // Translation helper / 翻译辅助函数
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // Get localized item name (for modifications) / 获取本地化的项目名称（用于修改项）
  getLocalizedItemName(item) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'name') || item.name
  }

  // Save productName
  // 保存 productName
  saveData(productName) {
    this.$store.commit('saveNavTitle', {
      prop: 'productName',
      val: productName
    })
  }

  // Edit Product
  // 编辑产品
  editProduct() {
    this.saveData(this.data.name)
    this.jumpToMenu()
  }

  jumpToMenu() {
    if (this.number) {
      this.$router.push({
        path: `/v/${this.venueId}/product/t/${this.number}/${this.data.id}`,
        query: {
          productGroupId: this.productGroupId,
          productId: this.index
        }
      })
    } else {
      this.$router.push({
        path: `/v/${this.venueId}/product/p/${this.data.id}`,
        query: {
          productGroupId: this.productGroupId,
          productId: this.index === 0 ? '0' : this.index
        }
      })
    }
  }

  delProduct() {
    if (this.isSubGroupMode) {
      this.$store.commit('deleteVenueSubGroupGoods', {
        product: this.data,
        venueId: this.selectVID,
      })
      this.__syncCurrentVenueCartWIthGroupCart(this.selectVID)
    } else {
      this.$store.commit('deleteGoods', {
        product: this.data
      })
      this.__syncVenueCartInGroupCartList(this.$store.state.productList)
    }
  }
}

export default OrderItems
</script>
